// @flow
import { relationshipReducer } from "src/utils/reducerUtils";
import riskSchema from "src/schemas/locationRiskSchema";

export const locationRiskRelationships = relationshipReducer({
  name: "locationRisks",
  relationshipSchemas: riskSchema.relationshipSchemas
});
